import Vue from 'vue'
import config from '@/config'

const TOKEN_KEY = config.TOKEN_NAME
const USER_KEY = 'userInfo'
const PHONE_KEY = 'phone'
const REMEMBER_PHONE_KEY = 'yqzx_remember_phone'

export const authStore = Vue.observable({
  token: null,
  user: null,
  phone: null
})

export function mergeUserInfo(base = {}, patch = {}, phone = '') {
  const data = { ...base, ...patch }
  const resolvedPhone = phone || data.phone || base.phone || authStore.phone || ''
  return {
    ...data,
    token: data.token || base.token || authStore.token || '',
    phone: resolvedPhone,
    nickname: data.nickname || base.nickname || '',
    avatar: data.avatar || base.avatar || '',
    level: data.level !== undefined ? data.level : (base.level || 1),
    currency: data.currency || base.currency || '0.00',
    sign: data.sign || base.sign || ''
  }
}

export function getToken() {
  return authStore.token || localStorage.getItem(TOKEN_KEY) || ''
}

export function initAuth() {
  authStore.token = localStorage.getItem(TOKEN_KEY)
  authStore.phone = localStorage.getItem(PHONE_KEY) || ''
  try {
    const raw = localStorage.getItem(USER_KEY)
    authStore.user = raw ? JSON.parse(raw) : null
  } catch {
    authStore.user = null
  }
}

export function isLoggedIn() {
  return !!getToken()
}

export function setToken(token) {
  authStore.token = token || ''
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  } else {
    localStorage.removeItem(TOKEN_KEY)
  }
}

export function setPhone(phone) {
  authStore.phone = phone || ''
  if (phone) {
    localStorage.setItem(PHONE_KEY, phone)
  } else {
    localStorage.removeItem(PHONE_KEY)
  }
}

export function setUser(user) {
  authStore.user = user || null
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  } else {
    localStorage.removeItem(USER_KEY)
  }
}

export function applyLoginResult(res, phone = '') {
  const userInfo = res.userInfo || res.user || res || {}
  const token = userInfo.token || res.token
  if (!token) return false

  const phoneTrim = phone || userInfo.phone || ''
  setToken(token)
  if (phoneTrim) setPhone(phoneTrim)
  setUser(mergeUserInfo({}, userInfo, phoneTrim))
  return true
}

export function rememberPhone(phone) {
  localStorage.setItem(REMEMBER_PHONE_KEY, phone)
}

export function getRememberedPhone() {
  return localStorage.getItem(REMEMBER_PHONE_KEY) || ''
}

export function clearRememberedPhone() {
  localStorage.removeItem(REMEMBER_PHONE_KEY)
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(PHONE_KEY)
  authStore.token = null
  authStore.user = null
  authStore.phone = null
}

export function getUser() {
  return authStore.user
}

export function getDisplayName(user = authStore.user) {
  if (!user) return authStore.phone || ''
  if (user.nickname) return user.nickname
  const phone = user.phone || authStore.phone || ''
  if (/^1\d{10}$/.test(phone)) {
    return `${phone.slice(0, 3)}****${phone.slice(-4)}`
  }
  return phone || '用户'
}
